// ─── src/components/ui/Image.jsx ─────────────────────────────────────────────
// The ONE way to render a listing / content image.
//
// It routes every src through the imgUrl transform (resize + WebP + Cloudflare cache),
// lazy-loads by default, decodes async, and falls back to a known-good image if the URL
// 404s. Use this instead of a raw <img> so the transform can never be forgotten the way
// DestinationsList once forgot it and shipped 1.5 MB originals as thumbnails.
//
// Props: src (required), width (default 1200), quality (default 75), resize ('contain' to
// scale without cropping), fallback (override or pass null to disable). Everything else
// (alt, className, style, loading="eager" for above-the-fold, onClick …) spreads through.
//
// For CSS background-image (not an <img>), call imgUrl() directly, a component can't set
// a background. That is the only sanctioned place to touch imgUrl by hand.
import { imgUrl } from '../../utils/imgUrl';

const DEFAULT_FALLBACK =
  'https://images.unsplash.com/photo-1519741497674-611481863552?auto=format&fit=crop&w=600&h=800&q=80';

export default function Image({ src, width = 1200, quality = 75, resize, fallback = DEFAULT_FALLBACK, ...rest }) {
  return (
    <img
      loading="lazy"
      decoding="async"
      {...rest}
      src={imgUrl(src, { width, quality, resize })}
      onError={(e) => {
        if (fallback && e.currentTarget.src !== fallback) e.currentTarget.src = fallback;
      }}
    />
  );
}
